import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Components Imports
import { Dropdown } from "../../../../../commonComponents";
import {
  preventEditorToDeactivate,
  updateDocumentClickedComponentID,
  updateComponentMeta,
} from "../../../../../actions/DocumentActions/index";
import { nukeActiveEditor } from "../../../../../actions/EditorActions/editorActions";
import {
  convertToTableField,
  editTableFormField,
} from "../../../../../actions/DocumentTemplateActions/templateActions";

// Internal Imports
import { DOCUMENTS } from "../../../../../constants";
import { checkTableDataSource } from "../../../../../utils/documentUtils";
// import { convertSectionTableForPlaceholder } from "../../../utils";

// Destructuring
const { DOCUMENT_MODE, TABLE_LEVEL_MORE_OPTIONS, DOCUMENT_COMPONENT_TYPES } =
  DOCUMENTS;

class PlaceHolderManageColBtn extends Component {
  state = { showHidePlaceholder: true };

  componentDidMount = () => {
    document.addEventListener("mousedown", this._handleClick, false);
  };

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this._handleClick, false);
  };

  _handleClick = e => {
    if (
      this.node &&
      !this.node.contains(e.target) &&
      this.props.showMoreTableOptionsDropdown
    ) {
      this.props.toggleDropdown(e, "TableMoreOptions");
      this.props.preventEditorToDeactivate(false);
    }

    if (
      this.node &&
      this.node.contains(e.target) &&
      this.props.showMoreTableOptionsDropdown
    ) {
      // prevent loosing editor focus when style/weight is selected
      this.props.preventEditorToDeactivate(true);
      e.preventDefault();
    }
  };

  _showManageColumnsForTable = section => {
    const columnsHeaders = this._createColumnHeaders(section);
    this.props.updateState({ columnsHeaders, showManageColumnPopup: true });
    this.props.updateDocumentClickedComponentID(null, true, null);
    this.props.nukeActiveEditor();
  };

  _createColumnHeaders = section => {
    if (
      section &&
      section.data &&
      section.data.data &&
      section.data.data.length > 0
    ) {
      const firstRowData = section.data.data[0].data;
      const columnHeaders = [];
      const dataSource = checkTableDataSource(section);
      firstRowData.forEach((col, index) => {
        let colName = "";
        if (col.data.html || col.data) {
          const span = document.createElement("span");
          if (section.type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET) {
            span.innerHTML = col.data.html;
          } else if (!dataSource && typeof col.data === "string") {
            span.innerHTML = col.data;
          } else if (!dataSource) {
            span.innerHTML = col.data.data.getPlainText();
          } else if (
            dataSource === DOCUMENT_COMPONENT_TYPES.DEAL_TABLE &&
            (typeof col.data === "string" || typeof col.data === "boolean")
          ) {
            span.innerHTML = col.data;
          } else if (dataSource === DOCUMENT_COMPONENT_TYPES.DEAL_TABLE) {
            span.innerHTML = col.data.data.getPlainText();
          } else if (dataSource === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET) {
            span.innerHTML = col.data.html;
          }
          colName = span.textContent || span.innerText;
        }
        let show = true;
        if (
          this.props.section &&
          this.props.section.data &&
          this.props.section.data.attributes &&
          this.props.section.data.attributes.hiddenCols &&
          this.props.section.data.attributes.hiddenCols.includes(index)
        ) {
          show = false;
        }
        const colHeader = { id: index, name: colName, show };
        columnHeaders.push(colHeader);
      });
      return columnHeaders;
    }
    return [];
  };

  _getBlockId = () => {
    let getBlockId = this.props.section.id;
    if (this.props.componentMeta.blockType === "COVERPAGE") {
      getBlockId = this.props.componentMeta.coverpageId;
    } else if (this.props.componentMeta.blockType === "HEADER") {
      getBlockId = this.props.componentMeta.headerId;
    } else if (this.props.componentMeta.blockType === "FOOTER") {
      getBlockId = this.props.componentMeta.footerId;
    }
    return getBlockId;
  };

  _convertToTableField = () => {
    // convertSectionTableForPlaceholder(this.props.section);
    this.props.convertToTableField({
      section: this.props.section,
      blockType: this.props.componentMeta.blockType,
      blockID: this._getBlockId(),
    });
    this.props.updateDocumentClickedComponentID(null, true, null);
    this.props.nukeActiveEditor();
    this.props.updateComponentMeta({});
  };

  _editTableField = () => {
    const blockID = this._getBlockId();
    this.props.editTableFormField(
      this.props.section,
      this.props.tableOptionsDetails,
      blockID,
      this.props.componentMeta.blockType,
    );
    this.props.updateDocumentClickedComponentID(null, true, null);
    this.props.nukeActiveEditor();
    this.props.updateComponentMeta({});
  };

  _removeTableField = () => {
    this.props.updateState({ showRemoveTableFormField: true });
    this.props.updateDocumentClickedComponentID(null, true, null);
    this.props.nukeActiveEditor();
    this.props.updateComponentMeta({});
  };

  _dropdownOptionsData = () => {
    const options = [];
    TABLE_LEVEL_MORE_OPTIONS.forEach(option => {
      switch (option.id) {
        // case "manage-col": {
        //   options.push({
        //     ...option,
        //     action: () => this._showManageColumnsForTable(this.props.section),
        //   });
        //   break;
        // }
        case "table-as-placeholder": {
          let isFormFieldAttached = false;
          if (
            this.props.mode === DOCUMENT_MODE.TEMPLATE &&
            this.props.fieldSectionMapping
          ) {
            isFormFieldAttached =
              Object.keys(this.props.fieldSectionMapping).findIndex(fieldID =>
                this.props.fieldSectionMapping[fieldID].includes(
                  this.props.section.id,
                ),
              ) > -1;
          }

          if (this.props.mode === DOCUMENT_MODE.DOCUMENT || isFormFieldAttached)
            break;
          options.push({
            ...option,
            action: () => this._convertToTableField(this.props.section),
          });
          break;
        }
        case "table-edit-placeholder": {
          if (
            this.props.mode === DOCUMENT_MODE.DOCUMENT ||
            !this.props.section.clauseOptions
          )
            break;
          options.push({
            ...option,
            action: () => this._editTableField(this.props.section),
          });
          break;
        }
        case "table-remove-placeholder": {
          if (
            this.props.mode === DOCUMENT_MODE.DOCUMENT ||
            !this.props.section.clauseOptions
          )
            break;
          options.push({
            ...option,
            action: () => this._removeTableField(),
          });
          break;
        }
        default:
      }
    });

    options.forEach((option, index) => {
      if (index === options.length - 2 && option.id === "unlink-table") {
        option.isBottomLine = true;
      }
    });

    if (options.length < 1) {
      this.setState({ showHidePlaceholder: false });
    }

    return {
      icon: "ellipsis-v",
      iconType: "far",
      position: this.props.dataSourceForNcol ? "right" : "bottomLeft",
      title: "Choose any of the options",
      selectedClassNameIdent: "",
      className: "assetitem-settings-dropdown",
      options,
    };
  };

  _toggleDropdownHandler = e => {
    // e.preventDefault();
    // this.props.preventEditorToDeactivate(false);
    this.props.toggleDropdown(e, "TableMoreOptions");
    // this.props.preventEditorToDeactivate(false);
  };

  _showTableMoreOptions = () => {
    const { readOnly } = this.props;

    return !readOnly ? (
      <div className="table-more-options styling-icons">
        <Fragment>
          <div
            ref={ele => {
              this.node = ele;
            }}
            className={`table-style-items table-datasource-icon ${
              this.props.dataSourceForNcol ? "table-datasource" : ""
            }`}>
            <span
              data-test="table-datasource-span"
              className={`btn-positive ${
                this.props.dataSourceForNcol ? "link-data-source" : ""
              }`}
              onMouseDown={e => {
                this.props.toggleDropdown(e, "TableMoreOptions");
              }}
              role="button"
              tabIndex={0}>
              {!this.props.dataSourceForNcol && (
                <i>
                  <FontAwesomeIcon icon={["far", "ellipsis-v"]} />{" "}
                </i>
              )}

              {this.props.dataSourceForNcol && (
                <div className="datasource-text-ncol">Check more options</div>
              )}
            </span>
            <Dropdown
              options={this._dropdownOptionsData()}
              showDropdown={this.props.showMoreTableOptionsDropdown}
              showDropdownHandler={this._toggleDropdownHandler}
            />
          </div>
        </Fragment>
      </div>
    ) : null;
  };

  render() {
    return (
      <Fragment>
        {this.state.showHidePlaceholder && this._showTableMoreOptions()}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { activeComponentMeta } = state.DocumentStore;
  const { showPriceBook } = state.QuotationStore;
  const { fieldSectionMapping } = state.TemplateStore;
  let focusRowID = null;
  let focusColumnID = null;

  const { tableRowId, tableColId } = activeComponentMeta;

  focusRowID = tableRowId !== undefined ? tableRowId : null;
  focusColumnID = tableColId !== undefined ? tableColId : null;
  const activeCell =
    focusRowID !== undefined && focusColumnID !== undefined
      ? [focusRowID, focusColumnID]
      : null;

  return {
    focusRowID,
    focusColumnID,
    activeCell,
    activeComponentMeta,
    showPriceBook,
    fieldSectionMapping,
  };
};

const mapDispatchToProps = {
  preventEditorToDeactivate,
  convertToTableField,
  editTableFormField,
  updateDocumentClickedComponentID,
  nukeActiveEditor,
  updateComponentMeta,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PlaceHolderManageColBtn);
